export const SAVE_COVID_19_IMPACT_RESET = "SAVE_COVID_19_IMPACT_RESET"
export const SAVE_COVID_19_IMPACT_REQUEST = "SAVE_COVID_19_IMPACT_REQUEST"
export const SAVE_COVID_19_IMPACT_SUCCESS = "SAVE_COVID_19_IMPACT_SUCCESS"
export const SAVE_COVID_19_IMPACT_FAILURE = "SAVE_COVID_19_IMPACT_FAILURE"


export const FETCH_COVID_19_IMPACT_REQUEST = "FETCH_COVID_19_IMPACT_REQUEST"
export const FETCH_COVID_19_IMPACT_SUCCESS = "FETCH_COVID_19_IMPACT_SUCCESS"
export const FETCH_COVID_19_IMPACT_FAILURE = "FETCH_COVID_19_IMPACT_FAILURE"